import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideImages, PURCHASE_ANCHOR } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const next = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(next);
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-4 py-6 sm:px-6" data-id="element-86" data-mp="1dwwxmolncu87">
      <div className="mx-auto max-w-3xl" data-id="element-87" data-mp="a2egf8mg04dt">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-petrol sm:text-3xl" data-id="element-88" data-mp="a138cwlysagw">
          Look inside
        </h2>
        <p className="mt-1 text-center font-heading text-sm font-semibold text-deep sm:text-base" data-id="element-89" data-mp="k0u2uyaiypgz">
          Discover What’s Inside CAREGIVER READY™
        </p>
        <p className="mx-auto mt-1 max-w-xl text-center text-xs leading-snug text-deep/80 sm:text-sm" data-id="element-90" data-mp="f2akt8z1xxtw">
          Explore daily planners, routine checklists, trackers, care notes,
          observation sheets, safety organizers, appointment tools, handoff forms
          and communication resources included throughout the complete system.
        </p>

        <div className="relative mt-4" data-id="element-91" data-mp="3sg5ho0zfcuiq">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto scroll-smooth rounded-xl" aria-label="Carousel of pages inside CAREGIVER READY" data-id="element-92" data-mp="3sf2spylnx25g">
            {insideImages.map((img, i) => <div key={img.src} className="w-full shrink-0 snap-center px-0.5" data-id="element-93" data-mp="13pn0p8ay4kym" data-mpi={i}>
                <a href={PURCHASE_ANCHOR} className="block" data-id="element-94" data-mp="18nesm2blc72t">
                  <img src={img.src} alt={`${img.caption} — page inside CAREGIVER READY™`} loading={i === 0 ? 'eager' : 'lazy'} className="w-full rounded-xl border border-petrol/15 bg-cream object-contain shadow-md" data-id="element-95" data-mp="18lty2cpa0o4y" />
                </a>
              </div>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full border border-petrol/20 bg-white/95 p-2 text-petrol shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-96" data-mp="pply9of195h1">
            <ChevronLeftIcon className="h-5 w-5" data-id="element-97" data-mp="2a3vzvzun0zdc" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full border border-petrol/20 bg-white/95 p-2 text-petrol shadow-md transition-opacity duration-150 ease-out disabled:opacity-30" data-id="element-98" data-mp="2k8kt0m85jnsv">
            <ChevronRightIcon className="h-5 w-5" data-id="element-99" data-mp="21i330pepf6b7" />
          </button>
        </div>

        <p className="mt-2 text-center font-heading text-xs font-bold uppercase tracking-wide text-petrol sm:text-sm" data-id="element-100" data-mp="1wj9s94qsxteq">
          {index + 1} / {insideImages.length} — {insideImages[index].caption}
        </p>

        <div className="mt-2 flex justify-center gap-2" data-id="element-101" data-mp="1niv4lyqd8282">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? 'w-6 bg-petrol' : 'w-2.5 bg-petrol/25'}`} data-id="element-102" data-mp="3lxy5t9b4phec" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}